import { Action, createReducer, on } from '@ngrx/store';
import { fetchLeadsList, fetchLeadsListFailure, fetchLeadsListSuccess } from './leads.action';


export interface LeadsState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: LeadsState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const LeadsReducer = createReducer(
  initialState,
  on(fetchLeadsList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchLeadsListSuccess, (state, { response }) => {
    console.log('response', response);

    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchLeadsListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  })
);

// Selector
export function reducer(state: LeadsState | undefined, action: Action) {
  return LeadsReducer(state, action);
}
